import styled from "styled-components";

export const Button = styled.button`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  color: white;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  cursor: pointer;
  background: #005DD7;
  font-family: Roboto;
  border: none;
  border-radius: 8px;
`;
